'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TableTd = function TableTd(props) {
  return _react2.default.createElement('td', props);
};

TableTd.displayName = 'Table.Td';
exports.default = TableTd;